export const round = (value: number, decimals = 2) =>
  Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals)
